#import "./RatingEntityResultFields.graphql"
fragment SupplierFields on Supplier {
  id
  __typename
  _urgencyLevel
  _sortName
  vendorNumber
  federalTaxReference
  vatNumber
  supplierRatingResults {
    ...RatingEntityResultFields
  }
  statusType {
    statusType
    approvalState
    _transactionIconStatus
  }
  _isUpdatable
  _isDeletable
  _rowTimestamp
}
